export default {
  data () {
    return {
      lists: null,
      desserts: null,
      categories: '',
      pagination: {
        current: 0,
        total: 0,
        length: 0
      }
    }
  },
  computed: {
    moreActivation () {
      if (this.pagination.length <= this.pagination.current) {
        return true
      }
      return false
    },
    listParams: {
      get () {
        return {
          pageNumber: 1,
          pageSize: 10
        }
      },
      set (val) {
        return val
      }
    }
  },
  methods: {
    async getListMobile (api, options, pageQueryName) {
      let queryName = 'page'
      if (pageQueryName) {
        queryName = pageQueryName
      }

      this.listParams = {
        ...options
      }
      const params = Object.assign({}, this.listParams, options)
      const { data } = await api(params)
      if (data) {
        this.lists = data.list

        const arr = data.list
        this.desserts = arr.slice(-this.listParams.pageSize)

        this.pagination = {
          current: Number(this.$route.query[queryName] || 1),
          length: Math.ceil(data.totalSize / this.listParams.pageSize),
          total: data.totalSize
        }
      } else {
        alert('데이터를 가져오는데 실패했습니다. 다시 시도해주세요')
      }
    },
    async getList (api, options) {
      this.listParams = {
        ...options
      }
      const params = Object.assign({}, this.listParams, options)
      const { data } = await api(params)
      // console.log('getList', data)
      if (data) {
        this.desserts = data.list
        this.pagination = {
          current: data.pageNumber,
          length: data.totalPageNumber,
          total: data.totalSize
        }
      } else {
        alert('데이터를 가져오는데 실패했습니다. 다시 시도해주세요')
      }

      if (document.querySelector('.tab-wrap')) {
        // const isPcHeader = window.matchMedia('(min-width: 980px)')
        // const headerHeight = isPcHeader.matches ? 72 : 50
        // document.documentElement.scrollTop = document.querySelector('.tab-wrap').offsetTop
      }
    },
    movePage (index) {
      this.pagination.current = index

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          page: index
        }
      }).catch(e => {})
    }
  }
}
